import * as tslib_1 from "tslib";
import { MipmapGenerator } from "@awayjs/graphics";
import { GL_ImageCube } from "../image/GL_ImageCube";
/**
 *
 * @class away.pool.ImageObjectBase
 */
var GL_BitmapImageCube = (function (_super) {
    tslib_1.__extends(GL_BitmapImageCube, _super);
    function GL_BitmapImageCube() {
        var _this = _super.apply(this, arguments) || this;
        _this._mipmapDataArray = new Array(6);
        return _this;
    }
    GL_BitmapImageCube.prototype.activate = function (index, mipmap) {
        if (mipmap && this._stage.globalDisableMipmap)
            mipmap = false;
        if (!this._texture) {
            this._createTexture();
            this._invalid = true;
        }
        if (!this._mipmap && mipmap) {
            this._mipmap = true;
            this._invalid = true;
        }
        if (this._invalid) {
            this._invalid = false;
            for (var i = 0; i < 6; ++i)
                this._texture.uploadFromImage(this._asset, i, 0);
            if (mipmap)
                this._texture.generateMipmaps();
        }
        // if (this._invalid) {
        // 	this._invalid = false;
        // 	for (var i:number = 0; i < 6; ++i) {
        // 		if (mipmap) {
        // 			var mipmapData:Array<BitmapImage2D> = this._mipmapDataArray[i] || (this._mipmapDataArray[i] = new Array<BitmapImage2D>());
        //
        // 			MipmapGenerator._generateMipMaps((<BitmapImageCube> this._asset).getCanvas(i), mipmapData, true);
        // 			var len:number = mipmapData.length;
        // 			for (var j:number = 0; j < len; j++)
        // 				(<ICubeTexture> this._texture).uploadFromImage(mipmapData[j], i, j);
        // 		} else {
        // 			(<ICubeTexture> this._texture).uploadFromImage(<BitmapImageCube> this._asset, i, 0);
        // 		}
        // 	}
        // }
        _super.prototype.activate.call(this, index, mipmap);
    };
    /**
     *
     */
    GL_BitmapImageCube.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        for (var i = 0; i < 6; i++) {
            var mipmapData = this._mipmapDataArray[i];
            if (mipmapData) {
                var len = mipmapData.length;
                for (var j = 0; j < len; i++)
                    MipmapGenerator._freeMipMapHolder(mipmapData[j]);
            }
        }
    };
    return GL_BitmapImageCube;
}(GL_ImageCube));
export { GL_BitmapImageCube };



// WEBPACK FOOTER //
// ../dist/lib/image/GL_BitmapImageCube.js